import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { ActionFeedbackModal } from "@/components/organisms/ActionFeedbackModal";
import { appRoutes } from "@/routes/AppRoutes";

// Data router (rather than <BrowserRouter><Routes/></BrowserRouter>) so a page
// can block navigation with `useBlocker` — see the unsaved-changes guard on the
// settings page. The route declarations themselves are unchanged.
const router = createBrowserRouter(appRoutes);

export default function App() {
  return (
    <>
      <RouterProvider router={router} />
      {/* Uses no router hooks, so it is fine outside the provider. */}
      <ActionFeedbackModal />
    </>
  );
}
